import { useSyncExternalStore, useCallback } from "react";

export type CitationMode = "compact" | "annotated";

const STORAGE_KEY = "iamu:citation-mode";
const DEFAULT: CitationMode = "annotated";

const listeners = new Set<() => void>();

function getSnapshot(): CitationMode {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "compact" || stored === "annotated") return stored;
  } catch {
    // SSR or storage unavailable
  }
  return DEFAULT;
}

function getServerSnapshot(): CitationMode {
  return DEFAULT;
}

function subscribe(callback: () => void): () => void {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

export function useCitationMode(): [
  CitationMode,
  (mode: CitationMode) => void,
] {
  const mode = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  const setMode = useCallback((next: CitationMode) => {
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // storage unavailable
    }
    for (const listener of listeners) listener();
  }, []);

  return [mode, setMode];
}
